<template id="findid">
  <validation-observer ref="validator" v-slot="{ errors }" :slim="true">
    <div>
      <ul class="tab has-tab2">
        <li class="tab-item active">
          <router-link class="tab-btn" to="/find/id">아이디 찾기</router-link>
        </li>
        <li class="tab-item">
          <router-link class="tab-btn" to="/find/password">비밀번호 찾기</router-link>
        </li>
      </ul>
      <div class="tab-body">
        <form
          id="form-find-id"
          class="form-find-id"
          @submit.prevent="onSubmitFindId"
        >
          <fieldset class="form-group form-login-username" :class="{ error: hasError(errors, '이름')}">
            <label for="name" class="form-label screen-reader-text">이름</label>
            <validator rules="required" name="이름">
              <input
                id="name"
                v-model="user.name"
                class="form-field"
                type="text"
                placeholder="이름/법인명을 적어주세요"
                name="name"
              >
            </validator>
          </fieldset>
          <fieldset class="form-group form-login-phone" :class="{ error: hasError(errors, '휴대폰')}">
            <label for="phone_num" class="form-label screen-reader-text">휴대폰</label>
            <validator :rules="['required', 'numeric']" name="휴대폰">
              <input
                id="phone_num"
                v-model="user.phone"
                class="form-field"
                type="text"
                placeholder="휴대폰 번호를 적어주세요"
                name="phone_num"
              >
            </validator>
          </fieldset>
          <fieldset class="form-group submit">
            <button type="submit" class="btn btn_lg btn_full">
              확인
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import jsonp from 'jsonp';
import config from 'config';
import DialogUtil from 'utils/dialog';

export default {
  name: 'FindId',
  components: {},
  data() {
    return {
      user: {
        name: null,
        phone: null,
      },
    };
  },
  computed: {},
  async created() {
    this.$gtag.event('view', {
      page_name: 'plan_contract_0_login_findmyid',
      event_category: document.title,
      page_url: document.URL,
    });
  },
  methods: {
    // 아이디 찾기
    async onSubmitFindId() {
      const valid = await this.$refs.validator.validate();
      if (valid) {
        const { name, phone } = this.user;
        jsonp(`${config.login.baseURL}/user/find_id?username=${name}&phone=${phone}`, {}, (err, res) => {
          if (!(res.result == null)) {
            DialogUtil.alert(res.retMsg);
          } else {
            console.log(err);
            DialogUtil.alert(res.retMsg);
          }
        });
      }
    },
  },
};

</script>
